import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';

export interface Props {
  children: any;
}

function FooterRowWrapper({ children }: Props) {
  return <Wrapper>{children}</Wrapper>;
}

const Wrapper = styled.div`
  display: flex;
  max-width: ${({ theme }) => `${theme.grid.container.wide}px`};
  padding: ${rem(32)} ${rem(24)};
  width: 100%;
  margin: 0 auto;
  border-bottom: ${({ theme }) => theme.borders.footer};
  justify-content: space-between;

  ${({ theme }) => theme.mediab.l925`
      flex-flow: column;
      align-items: center;
      padding: ${rem(32)} ${rem(24)} ${rem(8)};

      &:last-child {
        padding-bottom: ${rem(32)};
      }
  `};

  @media screen and (max-width: 1740px) {
    max-width: 1080px;
  }

  ${({ theme }) => theme.mediab.l1300`
    max-width: 960px
  `};
`;

export { FooterRowWrapper };
